<template>
    <div class="landing">
        <Header/>
        <div class="row justify-content-center align-items-center loading-wrapper" v-if="this.isLoading">
            <img src="../assets/loading-gif.gif" class="loading-gif"/>
        </div>
        <div class="game-background" v-if="!selectedSport"
             :style="{ backgroundImage: 'url(' + require(`../assets/${this.$environmentConfig.brand}/${backgroundImageUrl}`) + ')'}"></div>
        <div class="game-background" v-if="selectedSport === 'Soccer'"
             :style="{ backgroundImage: 'url(' + require(`../assets/${this.$environmentConfig.brand}/${soccerBackgroundImageUrl}`) + ')'}"></div>
        <div class="game-background" v-if="selectedSport === 'Olympics'"
             :style="{ backgroundImage: 'url(' + require(`../assets/${this.$environmentConfig.brand}/${olympicsBackgroundImageUrl}`) + ')'}"></div>
        <div class="game-background" v-if="selectedSport === 'Cricket'"
             :style="{ backgroundImage: 'url(' + require(`../assets/${this.$environmentConfig.brand}/${cricketBackgroundImageUrl}`) + ')'}"></div>
        <div class="col tab-container">
            <div class="row tab-rows">
                <p v-if="!selectedSport" class="col p-0 m-0 tab-text-size">Predict & Win!</p>
                <div v-if="selectedSport" class="row tab-rows">
                    <p class="col p-0 m-0 tab-text-size"><img class="tab-bar-img" :src="getSelectedSportIcon()" alt="">
                        Predict {{ selectedSport }}
                    </p>
                </div>
            </div>
            <div class="d-flex row tab-rows">
                <div v-for="(tab, index) in this.tabsConfig" :key="index" class="d-flex col tab-item"
                     v-on:click="onTabClicked(tab.onClickRouteTo)"
                     v-bind:class="(tab.isActive ? 'tab-bar-background-unselected' : 'tab-bar-background-selected')"
                     v-if="tab.isVisibile">
                    <p v-bind:class="(tab.isActive) ? 'tab-text-header-selceted tab-text-size' : 'tab-text-header-unselected tab-text-size'">
                        {{tab.title}}</p>
                </div>
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import Header from '@/components/Header.vue'

    export default {
        name: 'Landing',
        components: {
            Header
        },
        data: () => {
            return {
                backgroundImageUrl: window.innerWidth > 768 ? `generic-background-desktop.png` : `generic-background-mobile.png`,
                olympicsBackgroundImageUrl: window.innerWidth > 768 ? `olympic-background-desktop.png` : `olympic-background-mobile.png`,
                soccerBackgroundImageUrl: window.innerWidth > 768 ? `soccer-background-desktop.png` : `soccer-background-mobile.png`,
                cricketBackgroundImageUrl: window.innerWidth > 768 ? `vodacom-cricket-background-desktop.png` : `vodacom-cricket-background-mobile.png`,
                tabsConfig: [
                    {
                        title: 'Predictions',
                        activeRoutes: ['sports', 'leagues', 'rounds', 'make-predictions', 'current-predictions', 'soccer', 'olympics', 'cricket'],
                        isVisibile: true,
                        isActive: true,
                        onClickRouteTo: '/sports'
                    },
                    {
                        title: 'Leaderboards',
                        activeRoutes: ['your-winnings', 'leaderboard'],
                        isVisibile: true,
                        isActive: false,
                        onClickRouteTo: '/your-winnings'
                    },
                    {
                        title: 'Leaderboard',
                        activeRoutes: ['leaderboard'],
                        isVisibile: false,
                        isActive: false,
                        onClickRouteTo: '/leaderboard'
                    }
                ]
            }
        },
        computed: {
            ...mapState(['selectedSport', 'isLoading', 'yourWinningsSelected', 'user', 'token']),
        },
        methods: {
            ...mapMutations(['setMsisdn', 'setUsername', 'setIsYourWinningsSelected', 'setIsLoading', 'setUserData']),
            setBackgroundUrl() {
                this.backgroundImageUrl = window.innerWidth > 768 ? `generic-background-desktop.png` : `generic-background-mobile.png`;
                this.olympicsBackgroundImageUrl = window.innerWidth > 768 ? `olympic-background-desktop.png` : `olympic-background-mobile.png`;
                this.soccerBackgroundImageUrl = window.innerWidth > 768 ? `soccer-background-desktop.png` : `soccer-background-mobile.png`;
            },
            onTabClicked(onClickRouteTo) {
                this.$router.push(onClickRouteTo);
            },
            getSelectedSportIcon() {
                return require(`../assets/${this.$environmentConfig.brand}/${this.selectedSport.toLowerCase()}-icon-white.png`);
            }
        },
        watch: {
            $route(to) {
                let pathMatched = false;

                this.tabsConfig.forEach((tabConfig) => {
                    tabConfig.isActive = false;
                    if (!pathMatched) {
                        tabConfig.activeRoutes.forEach((activeRoute) => {
                            if (to.path.indexOf(activeRoute) > -1) {
                                pathMatched = true;
                                tabConfig.isActive = true;
                            }
                        });
                    }
                });
            }
        },
        created() {
            this.setIsLoading(true)
        },
        mounted() {
            this.setBackgroundUrl();
            window.addEventListener("resize", this.setBackgroundUrl.bind(this));
            this.setIsLoading(false);
            this.$router.push('/sports');

            window.addEventListener("beforeunload", (event) =>
            {
              if (event)
              {
                const url = this.token ? `${document.referrer}?fantasyToken=${this.token}` : document.referrer;
                window.open(url, '_self');

                // if(event.clientX < 40 && event.clientY < 0)
                // {
                //   debugger;
                //   console.log('History: ' + window.history);
                // }
                // else if(event.currentTarget.performance.navigation.type === 1)
                // {
                //   alert("Browser refresh button is clicked...");
                // } else if(event.currentTarget.performance.navigation.type == 2)
                // {
                //   debugger;
                //   console.log('History: ' + window.history);
                // } else
                // {
                //   alert("Browser refresh button is clicked...");
                // }
              }
            });
        }
    }
</script>

<style scoped lang="scss">

    .loading-wrapper {
        z-index: 10;
        position: fixed;
        top: 8vh;
        left: 0;
        width: 110vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.7);
    }

    .landing {
        position: relative;
    }

    .game-background {
        top: 0;
        left: 0;
        bottom: 0;
        width: 100vw;
        height: 100vh;
        position: fixed;
        background-position: center;
        transform: translateZ(0);
        -webkit-transform: translateZ(0);
        -webkit-background-size: cover !important;
        -moz-background-size: cover !important;
        -o-background-size: cover !important;
        background-repeat: no-repeat;
        background-size: cover;
        z-index: -1;
    }

    @media screen and (min-width: 900px) {
        .tab-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 8vh;
        }
    }

    .tab-container {
        margin-top: 8vh;
    }

    .tab-rows {
        align-items: center;
        height: 8vh;
    }

    @media screen and (min-width: 900px) {
        .tab-rows {
            justify-content: center;
            width: 80vw;
            align-items: center;
            height: 8vh;
        }
    }

    .tab-text-size {
        font-size: 2.5vh;
    }

    .my-predictions-bar {
        justify-content: center;
        align-items: center;
        background-color: $header-bg-color;
        box-shadow: 1px 1px 2px $icon-container-background-color;
        border-radius: 3px;
    }

    @media screen and (min-width: 900px) {
        .my-predictions-bar {
            justify-content: center;
            align-items: center;
            width: 80vw;
            background-color: $header-bg-color;
            box-shadow: 1px 1px 2px $icon-container-background-color;
            border-radius: 3px;
        }
    }

    .tab-item {
        justify-content: center;
        border-right: 1px solid $icon-container-background-color;
        //box-shadow: 1px 1px 2px $icon-container-background-color;
        height: 8vh;
    }

    .tab-bar-background-selected {
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, .7),
        0 -0.25rem 1.5rem $tab-item-unselected-color inset,
        0 0.75rem 0.5rem rgba(255, 255, 255, 0.4) inset,
        0 0.25rem 0.5rem 0 #d0cccc inset;
        background-color: $tab-item-unselected-color;
    }

    .tab-bar-background-unselected {
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, .7),
        0 -0.25rem 1.5rem $tab-item-selected-color inset,
        0 0.75rem 0.5rem rgba(255, 255, 255, 0.4) inset,
        0 0.25rem 0.5rem 0 #b10505 inset;
        background-color: $tab-item-selected-color
    }


    .tab-text-header-selceted {
        margin-top: 2vh;
        margin-bottom: 2vh;
        color: $tab-text-header-unselected-color;
    }

    .tab-text-header-unselected {
        margin-top: 2vh;
        margin-bottom: 2vh;
        color: $tab-text-header-selected-color;
    }

    .tab-text {
        color: $tab-text-color;
    }

    .underline {
        color: $icon-container-background-color;
        width: 80vw;
        padding: 0;
        margin: 0;
    }

    .tab-bar-img {
        height: 6vh;
    }

    @media screen and (min-width: 900px) {
        .tab-bar-img {
            height: 6vh;
        }
    }

    .points-text {
        font-size: 1vw;
        margin: 0;
        padding: 0;
    }

    @media screen and (max-width: 900px) {
        .points-text {
            font-size: 3vw;
            margin: 0;
            padding: 0;
        }
    }
</style>

